import { Text } from '@components'
import tokensRenamed from '@constants/tokensRenamed'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { Col, Container, Row } from '@mch-group/uikit-components'
import { PageContext } from '@providers/PageContext'
import classNames from 'classnames'
import { FC, useContext } from 'react'
import styled from 'styled-components'

const EMCaption: FC<IEMCaption> = ({ emcs_caption_title, emcs_caption_text, id }) => {
  const { page: { siteLanguage } } = useContext(PageContext)
  return (
    <section
      className={classNames('em-caption', siteLanguage === 'zh_CN' ?
        'mb-7 mb-md-8' : 'mb-9 mb-md-12')}
      id={id}>
      <Container className='px-5 px-lg-8 px-md-7'>
        <Row gutter='g-5 g-md-6 g-xl-7' className='justify-content-center my-0 py-0'>
          <Col xs={12} md={10} lg={8} xl={6} className='my-0 py-0'>
            <span className='text-large d-block mb-5'><b>{emcs_caption_title}</b></span>
            <StyledText className='caption-text' isHtml>{emcs_caption_text}</StyledText>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

const StyledText = styled(Text)`
  &.caption-text p strong {
    font-size: ${tokens.fontSize[3].value};
    line-height: ${tokensRenamed.lineHeights[4].value};
    margin-left: 0;
    margin-bottom: 0;
  }

  &.caption-text ol li,
  &.caption-text ol li p {
    font-size: ${tokens.fontSize[1].value};
    line-height: ${tokensRenamed.lineHeights[1].value};
    color: var(--bs-mch-gray-400);
  }

  ol {
    list-style-type: none;
    padding: 0;
    margin-bottom: 0;
  }

  ol,
  li {
    margin-bottom: 16px;
  }

  &.caption-text ol li {
    counter-increment: li;
    display: flex;
    flex-direction: row;
    gap: 16px;
  }

  &.caption-text ol li:nth-child(n+10)::before {
    content: counter(li) " ";
  }

  ol li::before {
    font-size: ${tokens.fontSize[1].value};
    line-height: ${tokensRenamed.lineHeights[1].value};
    color: var(--bs-mch-black);
    display: list-item;
    content: "0" counter(li) " ";
  }
`

interface IEMCaption {
  [key: string]: string
}

export default EMCaption